/* eslint no-template-curly-in-string: 0 */
import { PAYMENT_STATUSES } from "../../utils/enums";
import amazonLogo from '../../assets/images/logo-amazon.png';
import amazonCompleteImg from '../../assets/images/amazon.png';

const amazonBalance = {
  id: "AMAZON_BALANCE",
  displayName: "Amazon Balance",
  paymentFlow: "oauth",
  cssClassPrefix: "amazon",
  themeColor: "#ff9900",
  errors: {
    acceptPayment: {
      title: "Error Transferring Funds",
      message:
        "An error occurred when applying the credit to the Amazon account specified. Please select a different payment method."
    }
  },
  faqs: {
    byPaymentStatus: {
      [PAYMENT_STATUSES.PENDING_ACCEPTANCE]: [
        {
          answer: "In order to provide payment directly to your account with these services, you must (a) verify your identity and (b) permit us to receive information about your Amazon account. Please note that the login process is provided by Amazon and ${programName} never sees or receives your login information. All of these actions use industry-standard security methods to ensure that your data is protected.",
          question: "Why am I being asked to provide my username and password for Amazon®?"
        }
      ]
    }
  },
  paywall: {
    tile: {
      displayName: ["Amazon Balance"],
      tagline: ["Use online right now"],
      description: [
        {
          string: "Immediate funds to buy personal items, ",
          type: "div",
        },
        {
          string: "gifts, food and more",
          type: "div"
        }
      ],
      // btnLabel: "Go",
      logo: amazonLogo,
    }
  },
  recipientLogin: {
    flow: "oauth",
    redirectingToOauth: {
      title: "Redirecting to Amazon",
    },
  },
  acceptPayment: {
    css: {
      ":root": {
        "--btn-primary-bg-color": "#f8991d",
        "--btn-primary-bg-color-hover": "#f8991d",
        "--btn-primary-font-color": "#fff",
        "--btn-primary-font-color-hover": "#fff"
      },
    },
    flow: 'auto-accept',
    btnLabel: "Apply to ${paymentNetwork.displayName}",
    imgSrc: amazonCompleteImg,
    disclaimer: [
      {
        string:
          'Amazon.com is not a sponsor of this promotion. Except as required by law, Amazon.com Gift Cards ("GCs") cannot be transferred for value or redeemed for cash. GCs may be used only for purchases of eligible goods at Amazon.com or certain of its affiliated websites. For complete terms and conditions, see <a class="link" target="_blank" href="https://www.amazon.com/gc-legal">www.amazon.com/gc-legal</a>. GCs are issued by ACI Gift Cards, Inc., a Washington corporation. All Amazon ®, ™ & © are IP of Amazon.com, Inc. or its affiliates. No expiration date or service.',
        props: {
          style: {
            fontSize: "0.8rem",
            lineHeight: "1.2",
            padding: "0 1em",
            display: "block",
            textAlign: "center",
            marginBottom: "2em",
          }
        }
      }
    ]
  },
  paymentComplete: {
    css: {
      ":root": {
        "--btn-primary-bg-color": "#f8991d",
        "--btn-primary-bg-color-hover": "#f8991d",
        "--btn-primary-font-color": "#fff",
        "--btn-primary-font-color-hover": "#fff"
      },
    },
    imgSrc: amazonCompleteImg,
    initial: {
      secondaryText: [
        "A confirmation email will be sent to ",
        {
          string: "${payment.recipientEmail}",
          props: {
            className: 'payment-recipientEmail'
          }
        },
        ". Please allow a few minutes for your account to update."
      ]
    },
    buttonContainerProps: {
      vertical: true,
    },
    actions: [
      {
        type: "Button",
        props: {
          label: "Shop Now at Amazon",
          href:
            "https://www.amazon.com/gp/yourstore/home/ref=nav_cs_ys?&_encoding=UTF8&tag=sipree-20&linkCode=ur2&linkId=20b1fff84e0f8e99352c908146cdcce4&camp=1789&creative=9325"
        }
      },
      {
        type: "Button",
        props: {
          label: "View Amazon Balance",
          inverted: true,
          href: "https://www.amazon.com/gp/css/gc/balance/"
        }
      }
    ],
  },
  onHold: {
    imgSrc: amazonCompleteImg,
  }
};

export default amazonBalance;
